import axios from 'axios';

export interface BroadcastRequest {
  channel: 'SMS' | 'WHATSAPP' | 'BOTH';
  messageText: string;
  recipientScope: 'ALL_STUDENTS' | 'ALL_TEACHERS' | 'CLASS' | 'SECTION';
  classId?: number | null;
  sectionId?: number | null;
}

const API_URL = `${process.env.REACT_APP_API_URL}/api/broadcast`;

export const getHeaders = () => {
  const token = localStorage.getItem('token');
  const tenantId = localStorage.getItem('tenantSchema') || localStorage.getItem('lastSchoolId');
  const headers: Record<string, string> = {
    Authorization: `Bearer ${token}`
  };
  if (tenantId) {
    headers['X-Tenant-ID'] = tenantId;
  }
  return headers;
};

export const previewBroadcast = (payload: BroadcastRequest) =>
  axios.post(`${API_URL}/preview`, payload, { headers: getHeaders() });

export const sendBroadcast = (payload: BroadcastRequest) =>
  axios.post(`${API_URL}/send`, payload, { headers: getHeaders() });

export const getCampaignHistory = (page = 0, size = 10) =>
  axios.get(`${API_URL}/history`, {
    params: { page, size },
    headers: getHeaders()
  });

export const getCampaignDetail = (campaignId: number) =>
  axios.get(`${API_URL}/campaign/${campaignId}`, { headers: getHeaders() });

export const getWalletBalance = () =>
  axios.get(`${API_URL}/wallet/balance`, { headers: getHeaders() });

export const getTransactionHistory = (page = 0, size = 10) =>
  axios.get(`${API_URL}/wallet/transactions`, {
    params: { page, size },
    headers: getHeaders()
  });

const PURCHASE_URL = `${process.env.REACT_APP_API_URL}/api/school-admin/messaging`;

export const createStripeSession = (channel: string, amountInRupees: number) =>
  axios.post(`${PURCHASE_URL}/buy/create-checkout-session`, { channel, amountInRupees }, { headers: getHeaders() });

export const verifyStripeSession = (sessionId: string, channel: string, creditAmount: number) =>
  axios.post(
    `${PURCHASE_URL}/buy/verify-checkout-session`,
    { sessionId, channel, creditAmount },
    { headers: getHeaders() }
  );

export const getMyOrders = (page = 0, size = 10) =>
  axios.get(`${PURCHASE_URL}/buy/my-orders`, {
    params: { page, size },
    headers: getHeaders()
  });
